// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframes[data-v-23ea21d8] {\n  width: calc(100vw);\n  height: calc(100vh);\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
